'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _covutils = require('covutils');

Object.defineProperty(exports, 'minMax', {
  enumerable: true,
  get: function get() {
    return _covutils.minMax;
  }
});
Object.defineProperty(exports, 'indicesOfNearest', {
  enumerable: true,
  get: function get() {
    return _covutils.indicesOfNearest;
  }
});
Object.defineProperty(exports, 'indexOfNearest', {
  enumerable: true,
  get: function get() {
    return _covutils.indexOfNearest;
  }
});
exports.assert = assert;
exports.shallowcopy = shallowcopy;
exports.getNamespacePrefixes = getNamespacePrefixes;


var PREFIX = 'https://covjson.org/def/';
var CORE_PREFIX = exports.CORE_PREFIX = PREFIX + 'core#';
var DOMAINTYPES_PREFIX = exports.DOMAINTYPES_PREFIX = PREFIX + 'domainTypes#';

/**
 * @ignore
 */
function assert(condition, message) {
  if (!condition) {
    message = message || 'Assertion failed';
    throw new Error(message);
  }
}

/**
 * @ignore
 */
function shallowcopy(obj) {
  var copy = Object.create(Object.getPrototypeOf(obj));
  for (var prop in obj) {
    copy[prop] = obj[prop];
  }
  return copy;
}

/**
 * Extracts all the directly included namespaces from the `@context` field,
 * not following remote JSON-LD contexts.
 * 
 * @ignore
 * @param doc A JSON-LD document. 
 * @returns {Map<string,string>} 
 */
function getNamespacePrefixes(doc) {
  var context = doc['@context'];
  if (!context) {
    return;
  }
  if (!Array.isArray(context)) {
    context = [context];
  }
  var prefixes = new Map();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = context[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (typeof item === 'string') {
        continue;
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(item)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (typeof item[key] === 'string') {
            prefixes.set(key, item[key]);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return prefixes;
}